import { TFunction } from "i18next";
import { CheckinAndMaxAdvancedBooking } from "../../../Login/typings/login.types";

export const generateCheckinRowContents = (
  setting: CheckinAndMaxAdvancedBooking,
  t: TFunction
): string => {
  let mainContent = "";

  // 1. if allowedBookingDaysInAdvance exists, display it first in 'day' unit
  if (setting.checkinBufferTime) {
    mainContent = `${setting.checkinBufferTime} ${t("mins")}`;
  }

  return mainContent ?? "";
};
